import type { Game } from '../../game/Game';
import { registerPanel } from '../../ui/app/App';
import { openPanel } from '../../ui/app/store';
import { HavenPanel } from './HavenPanel';
import { applyQuartermaster, havenGame, havenSystem, openStation } from './runtime';
import './haven.css';

/**
 * Haven Isle (stronghold): research tree, workshop crafting, crew dispatch,
 * herb garden and Haven level. Other systems read research effects through
 * `havenBonus(account, key)`.
 */

let installedOn: Game | null = null;

export function install(game: Game): void {
  if (installedOn === game) return;
  installedOn = game;
  havenGame.current = game;
  registerPanel('haven', HavenPanel);
  const prev = game.interactHandlers.get('station');
  game.interactHandlers.set('station', (g, id) => openStation(g, id) || (prev?.(g, id) ?? false));
  game.systems.push(havenSystem);
  game.zoneSetups.push((g) => applyQuartermaster(g));
  game.hud.addMenuButton('Haven', 'Alt+U', () => openPanel('haven'));
}

export { havenBonus, tickHaven, havenLevelFor, missionOdds, gardenView } from './logic';
export type { HavenBonusKey } from './data';
export { RESEARCH, RECIPES, MISSIONS, CROPS, CREW } from './data';
